<table class="pricing-table">
    <colgroup>
        <col />
        <col *ngFor="let plan of plans" />
    </colgroup>
    <tbody>
        <ng-container *ngFor="let segment of planFeatureSegments">
            <ng-container *ngIf="'settings.customer-subscription.plan-features.' + segment | translate as labels">
                <tr>
                    <th>
                        {{ labels.title }}
                    </th>

                    <th *ngFor="let plan of plans" [class.active]="plan === selectedPlan"></th>
                </tr>

                <tr *ngFor="let feature of planFeatures[segment]">
                    <td>
                        {{ labels[feature.feature] }}
                    </td>

                    <td
                        *ngFor="let plan of plans"
                        [ngSwitch]="feature.plans[plan]"
                        [class.active]="plan === selectedPlan"
                    >
                        <i *ngSwitchCase="false" class="a-color-disabled">
                            <svg class="adspt-icon">
                                <use xlink:href="#adspt-empty-line"></use>
                            </svg>
                        </i>

                        <i *ngSwitchCase="true" class="a-color-light-blue">
                            <svg class="adspt-icon">
                                <use xlink:href="#adspt-check"></use>
                            </svg>
                        </i>

                        <ng-container *ngSwitchDefault>
                            {{ getFeatureLabel(labels, feature.plans[plan]) }}
                        </ng-container>
                    </td>
                </tr>
            </ng-container>
        </ng-container>
    </tbody>
</table>
